import { isServer } from '@/utils/runtime'

const MANAGE_CHANNEL_ID = 'manageChannelId'

const useLocalStorage = () => {
  const getManageChannelId = (): number | undefined => {
    return Number(getItem(MANAGE_CHANNEL_ID)) || undefined
  }

  const setManageChannelId = (channelId: string | number) => {
    setItem(MANAGE_CHANNEL_ID, `${channelId}`)
  }

  const removeManageChannelId = () => {
    removeItem(MANAGE_CHANNEL_ID)
  }

  return {
    getManageChannelId,
    setManageChannelId,
    removeManageChannelId,
  }
}

export default useLocalStorage

const setItem = (key: string, value: string) => {
  if (isServer) {
    return
  }
  localStorage.setItem(key, value)
}

const getItem = (key: string) => {
  if (isServer) {
    return undefined
  }
  return localStorage.getItem(key)
}

const removeItem = (key: string) => {
  if (isServer) {
    return
  }
  localStorage.removeItem(key)
}
